import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Typography,
  Collapse,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { FancyTextButton, RoundIconButton } from "components/Base/Buttons";

const Navbar = () => {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinkSx = {
    color: "rgba(255,255,255,0.85)",
    "&:hover": { color: "#4ade80" },
  };

  const handleToggleMobile = () => setMobileOpen((prev) => !prev);
  const handleCloseMobile = () => setMobileOpen(false);

  return (
    <AppBar
      position="sticky"
      sx={{
        background: "rgba(15,23,42,0.9)",
        backdropFilter: "blur(10px)",
        color: "white",
        boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
      }}
    >
      <Toolbar
        sx={{
          position: "relative",
          justifyContent: "space-between",
        }}
      >
        {/* Brand */}
        <Typography
          variant="subtitle1"
          noWrap
          component="a"
          href="/"
          onClick={handleCloseMobile}
          sx={{
            ml: 1,
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            letterSpacing: ".05rem",
            color: "inherit",
            textDecoration: "none",
            transition: "color 0.3s ease",
            "&:hover": {
              color: theme.custom?.base?.primary?.dark || "#4ade80",
            },
          }}
        >
          PATHWAYS
        </Typography>

        {/* Desktop nav — centred relative to the page */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >

          <Button sx={navLinkSx} href="/for/">
            Who is Pathways for?
          </Button>

          <Button sx={navLinkSx} href="/solutions/">
            Solutions
          </Button>

          <Button sx={navLinkSx} href="/features/">
            Features
          </Button>

          
        </Box>

        {/* Desktop CTAs */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
          <FancyTextButton fancyVariant="gradient" href="/register/">
            Register
          </FancyTextButton>

          <FancyTextButton fancyVariant="gradient" href="/login/">
            Login
          </FancyTextButton>
        </Box>

        {/* Mobile hamburger */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <RoundIconButton
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            colour="clear"
            displaySize="separate"
            icon={mobileOpen ? <CloseIcon /> : <MenuIcon />}
            iconColor="white"
            hoverIconColor="white"
            hoverBackgroundColor="rgba(255,255,255,0.08)"
            onClick={handleToggleMobile}
          />
        </Box>
      </Toolbar>

      {/* Mobile dropdown */}
      <Collapse in={mobileOpen} timeout="auto" unmountOnExit>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
            px: 2,
            pb: 2,
            gap: 1,
          }}
        >
          <Divider sx={{ borderColor: "rgba(255,255,255,0.12)", mb: 1 }} />

          <Button
            fullWidth
            sx={{ ...navLinkSx, justifyContent: "flex-start" }}
            href="/features/"
            onClick={handleCloseMobile}
          >
            Features
          </Button>
          <Button
            fullWidth
            sx={{ ...navLinkSx, justifyContent: "flex-start" }}
            href="/solutions"
            onClick={handleCloseMobile}
          >
            Solutions
          </Button>

          {/*
          <Button
            fullWidth
            sx={{ ...navLinkSx, justifyContent: "flex-start" }}
            href="/pricing/"
            onClick={handleCloseMobile}
          >
            Pricing
          </Button>

          */}

          <Divider sx={{ borderColor: "rgba(255,255,255,0.12)", my: 1 }} />

          <FancyTextButton
            fullWidth
            fancyVariant="gradient"
            pill={false}
            href="/register/"
            onClick={handleCloseMobile}
          >
            Register
          </FancyTextButton>

          <FancyTextButton
            fullWidth
            fancyVariant="gradient"
            pill={false}
            href="/login/"
            onClick={handleCloseMobile}
          >
            Login
          </FancyTextButton>
        </Box>
      </Collapse>
    </AppBar>
  );
};

export default Navbar;